<template>
    <div class="excel-uploader">
        <div class="mb-3 d-flex justify-content-start">
            <button @click="exportarPlantilla" class="btn btn-success">
                <i class="fas fa-file-download mr-2"></i>Descargar plantilla Excel
            </button>
        </div>
        <DropFileBasic ref="DropFileBasic" @handleFileData="handleFileUpload" @change="handleFileUpload" :fileTypes="[
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ]" />
        <div v-if="excelData.length > 0" class="preview-table mt-4">
            <h3 class="h4 mb-3">Vista Previa de Datos</h3>
            <div class="table-responsive">
                <table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th v-for="(header, index) in headers" :key="index">{{ header }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, rowIndex) in excelData" :key="rowIndex">
                            <td v-for="(value, colIndex) in row" :key="colIndex">{{ value }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-flex justify-content-between mt-3">
                <button @click="limpiarDatosExcel()" class="btn btn-secondary">
                    <i class="fas fa-times mr-2"></i>Cancelar
                </button>
                <button @click="importarDatos()" class="btn btn-primary">
                    <i class="fas fa-file-import mr-2"></i>Importar Puntos
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import * as XLSX from "xlsx";
import DropFileBasic from "@/components/helexium/DropFileBasic.vue";
import Swal from "sweetalert2";
import plantillaPuntosBase64 from "./plantillaPuntosBase64";

export default {
    name: 'ExcelUploader',
    components: {
        DropFileBasic
    },
    props: {
        // Plantillas disponibles para buscar por ID
        plantillasDisponibles: {
            type: Array,
            required: true
        },
        puntosEntregaExistentes: {
            type: Array
        }
    },
    data() {
        return {
            excelData: [],
            headers: [],
            personaEmpresaId: null
            // Nombres exactos de las columnas esperadas
        };
    },
    mounted() {
        const persona = JSON.parse(localStorage.getItem("setPersonaAct"));
        this.personaEmpresaId = persona.empresa.id;
    },
    methods: {
        exportarPlantilla() {
            try {
                //Crear plantilla en base 64 para facilitar su edición
                const excelBase64 = plantillaPuntosBase64;

                // Convertir base64 a blob
                const byteCharacters = atob(excelBase64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                // Crear URL del blob
                const url = window.URL.createObjectURL(blob);

                // Crear enlace y descargar
                const link = document.createElement('a');
                link.href = url;
                link.download = 'plantilla_masivo_puntos_entrega.xlsx';

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Liberar el objeto URL
                window.URL.revokeObjectURL(url);

                this.mostrarNotificacion(
                    'success',
                    'Plantilla exportada',
                    'La plantilla de Excel se ha descargado correctamente.'
                );
            }
            catch (error) {
                console.log("Error al exportar la plantilla:", error);
                this.mostrarNotificacion(
                    'error',
                    'Error',
                    'No se pudo exportar la plantilla de Excel'
                );
            }
        },




        mostrarNotificacion(tipo, titulo, mensaje) {
            Swal.fire({
                icon: tipo,
                title: titulo,
                text: mensaje,
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            });
        },

        handleFileUpload(event) {
            const file = event;
            if (!file) return;

            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });

                // Tomar la primera hoja
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                // Convertir a JSON
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                //console.log("PARSEO DE LA INFORMACIÓN", jsonData)

                // Extraer encabezados y datos
                this.headers = jsonData[0] || [];
                this.excelData = jsonData.slice(1);

                if (this.excelData === null || this.excelData === undefined || this.excelData.length === 0 || this.excelData.every(fila => fila.length === 0)) {
                    this.mostrarNotificacion(
                        'error',
                        'Ingrese información',
                        'No se pudo exportar la plantilla de Excel, sin información en el excel.'
                    );

                    this.limpiarDatosExcel();

                    return;
                }

                /*const resultadoValidacion = this.validarLugarEntrega(
                    this.excelData,
                    this.headers,
                    this.puntosEntregaExistentes || []
                );

                if (!resultadoValidacion) {
                    this.limpiarDatosExcel();
                    return;
                }*/

                const resultadoValidacionCoordenadas = this.validarCoordenadas(
                    this.excelData,
                    this.headers
                )
                if (!resultadoValidacionCoordenadas) {
                    this.limpiarDatosExcel();
                    return;
                }

                console.log("Datos de Excel validados correctamente.", this.excelData);
            };

            reader.readAsArrayBuffer(file);
        },


        // validarLugarEntrega(excelData, headers, nombresNoPermitidos) {
        //     const lugarIndex = headers.findIndex(
        //         header => typeof header === "string" && header.toLowerCase() === "lugarentrega"
        //     );
        //     if (lugarIndex === -1) {
        //         return { valido: false, mensaje: 'No se encontró la columna "lugarEntrega" en el archivo Excel.' };
        //     }

        //     // Verificar que ninguna fila tenga un valor en "lugarEntrega" que coincida con algún nombre del arreglo
        //     const conflicto = excelData.filter(fila => {
        //         if (fila[lugarIndex]) {
        //             return nombresNoPermitidos.some(nombre =>
        //                 fila[lugarIndex].toString().toLowerCase() === nombre.toString().toLowerCase()
        //             );
        //         }
        //         return false;
        //     });
        //     console.log(conflicto)
        //     let nombreFilaConflicto = conflicto.map(fila => fila[lugarIndex])

        //     if (conflicto.length > 0) {
        //         const listaConflictos = '<ul class="list-group text-start">' +
        //             nombreFilaConflicto.map(nombre => `<span class="list-group-item">${nombre}</span>`).join('') +
        //             '</ul>';

        //         // Mostrar la alerta con SweetAlert2
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'Error en la data',
        //             html: `La columna "lugarEntrega" contiene puntos ya creados:<br>${listaConflictos}`
        //         });
        //         return false;
        //     }
        //     return true;
        // },

        validarCoordenadas(excelData, headers) {
            const latIndex = headers.findIndex(
                header => typeof header === "string" && header.toLowerCase() === "latubicacionentrega"
            );
            const longIndex = headers.findIndex(
                header => typeof header === "string" && header.toLowerCase() === "longubicacionentrega"
            );
            if (latIndex === -1) {
                return this.mostrarNotificacion('warning', 'Alerta', 'No se encontró la columna "latUbicacionEntrega" en el archivo Excel.');
            }
            if (longIndex === -1) {
                return this.mostrarNotificacion('warning', 'Alerta', 'No se encontró la columna "longUbicacionEntrega" en el archivo Excel.');
            }

            console.log("Este es el index de las latitudes", latIndex);
            console.log("Este es el index de las longitudes", longIndex);

            // Aquí se verifica si alguna fila tiene una latitud no válida
            const latitudErronea = excelData.some(fila => {
                if (fila[latIndex]) {
                    console.log("Validando", fila[latIndex]);
                    // Retornamos true si la latitud es inválida
                    return !this.isValidCoord(fila[latIndex]);
                }
                // Si no hay dato en la celda, se puede considerar inválido o simplemente omitir
                return false;
            });
            const longitudErronea = excelData.some(fila => {
                if (fila[longIndex]) {
                    console.log("Validando", fila[longIndex]);
                    return !this.isValidCoord(fila[longIndex]);
                }
                return false;
            });

            if (latitudErronea && longitudErronea) {
                this.mostrarNotificacion('warning', 'Alerta', 'Hay latitudes y longitudes con formato erróneo formato requerido ejemplo:"0.00000000", "180.000000""');
                return false;

            }
            if (latitudErronea) {
                this.mostrarNotificacion('warning', 'Alerta', 'Hay latitudes con formato erróneo requerido ejemplo:"0.00000000", "180.000000""');
                return false;
            }
            if (longitudErronea) {
                this.mostrarNotificacion('warning', 'Alerta', 'Hay longitudes con formato erróneo requerido ejemplo:"0.00000000", "180.000000""');
                return false;
            }
            return true;
        },

        isValidCoord(coord) {
            if (coord === null || coord === "") return false;
            const latStr = coord.toString().trim();

            if (latStr.includes(",") || (latStr.match(/\./g) || []).length > 1) {
                return false;
            }

            // Validar formato con expresión regular
            if (!/^-?\d+(\.\d+)?$/.test(latStr)) {
                return false;
            }

            const coordenadesValidates = parseFloat(latStr);
            return !isNaN(coordenadesValidates) && coordenadesValidates >= -180 && coordenadesValidates <= 180;
        },

        limpiarDatosExcel() {
            this.excelData = [];
            this.headers = [];
            this.$emit('limpiar');
            this.$refs.DropFileBasic.restaurar();
        },

        importarDatos() {
            if (this.excelData.length === 0) {
                this.mostrarNotificacion(
                    'warning',
                    'Sin datos',
                    'No hay datos para importar'
                );
                return;
            }

            // Mostrar indicador de carga
            this.isLoading = true;

            try {
                const plantillas = this.excelData.map(row => {
                    const plantilla = {};

                    // Mapear cada columna según su posición en los encabezados
                    this.headers.forEach((header, index) => {
                        const headerNormalizado = this.normalizarNombreEncabezado(header);

                        // Asignar el valor correspondiente
                        if (row[index] !== undefined) {
                            plantilla[headerNormalizado] = row[index];
                        }
                    });
                    plantilla.estado = "1";
                    plantilla.empresaId = this.personaEmpresaId;

                    if (plantilla.codigoSN !== undefined || plantilla.contactoPersonaCliente !== undefined) {
                        plantilla.codigoSN = plantilla.codigoSN.toString();
                        plantilla.nombreCliente = plantilla.nombreCliente.toString();
                        plantilla.lugarEntrega = plantilla.lugarEntrega.toString();
                        plantilla.direccionPuntoEntrega = plantilla.direccionPuntoEntrega.toString();
                        plantilla.latUbicacionEntrega = plantilla.latUbicacionEntrega.toString();
                        plantilla.longUbicacionEntrega = plantilla.longUbicacionEntrega.toString();
                        plantilla.nombrePersonaCliente = plantilla.nombrePersonaCliente.toString();
                        plantilla.ubicacion = plantilla.ubicacion.toString();
                        plantilla.contactoPersonaCliente = plantilla.contactoPersonaCliente.toString();
                    }
                    return plantilla;
                })
                console.log("A CARGAR: ", plantillas)

                if (plantillas.length === 0) {
                    this.isLoading = false;
                    this.mostrarNotificacion(
                        'error',
                        'Datos inválidos',
                        'No se encontraron plantillas válidas para importar'
                    );
                    return;
                }

                // Llamar al endpoint de carga masiva
                this.enviarPlantillasAlServidor(plantillas);
            } catch (error) {
                this.isLoading = false;
                console.error("Error al procesar los datos para importar:", error);
                this.mostrarNotificacion(
                    'error',
                    'Error',
                    'Ocurrió un error al procesar los datos para importar'
                );
            }
        },

        // Método para enviar las plantillas al servidor
        async enviarPlantillasAlServidor(plantillas) {
            try {
                // Mostrar información de progreso
                this.mostrarNotificacion(
                    'info',
                    'Procesando',
                    `Enviando ${plantillas.length} plantillas al servidor...`,
                    5000 // 5 segundos
                );
                // Realizar la petición al endpoint
                const response = await this.$store.dispatch("hl_post", {
                    path: "EntregasApp/BulkCreate",
                    data: plantillas
                });
                console.log("Respuesta del servidor", response)
                // Procesar la respuesta
                const data = await response;

                if (response.success) {
                    // Éxito
                    this.mostrarNotificacion(
                        'success',
                        'Importación exitosa',
                        `Se importaron ${data.processedCount} plantillas correctamente`
                    );
                    this.$emit("obtenerPlantillasActualizadas");
                    // Limpiar datos y refrescar lista si es necesario
                    this.limpiarDatosExcel();
                } else {
                    // Error con detalles del servidor
                    console.error("Error del servidor:", data);

                    // Mostrar errores específicos si están disponibles
                    if (data.errors && data.errors.length > 0) {
                        // Si hay muchos errores, mostrar solo los primeros 3 y un resumen
                        const errorsToShow = data.errors.slice(0, 3);
                        const remainingErrors = data.errors.length - 3;

                        let errorMessage = errorsToShow.join('\n');
                        if (remainingErrors > 0) {
                            errorMessage += `\n...y ${remainingErrors} errores más.`;
                        }

                        this.mostrarNotificacion(
                            'error',
                            'Error en la importación',
                            errorMessage,
                            10000 // 10 segundos para leer los errores
                        );
                    } else {
                        // Mensaje de error genérico
                        this.mostrarNotificacion(
                            'error',
                            'Error en la importación',
                            data.message || 'No se pudieron importar las plantillas'
                        );
                    }
                }
            } catch (error) {
                console.error("Error al enviar plantillas al servidor:", error);
                this.mostrarNotificacion(
                    'error',
                    'Error de conexión',
                    'No se pudo conectar con el servidor. Intente nuevamente más tarde.'
                );
            } finally {
                this.isLoading = false;
            }
        },

        // Método para normalizar nombres de encabezados
        normalizarNombreEncabezado(header) {
            // Convertir a camelCase y eliminar espacios/caracteres especiales
            const headerLimpio = header.trim()
                .toLowerCase()
                .replace(/[^\w\s]/gi, '') // Eliminar caracteres especiales
                .replace(/\s+/g, ''); // Eliminar espacios

            // Mapeo de nombres comunes a propiedades del modelo
            const mapeoEncabezados = {
                'lugarentrega': 'lugarEntrega',
                'lugar': 'lugarEntrega',
                'latitud': 'latUbicacionEntrega',
                'lat': 'latUbicacionEntrega',
                'latubicacionentrega': 'latUbicacionEntrega',
                'longitud': 'longUbicacionEntrega',
                'long': 'longUbicacionEntrega',
                'longubicacionentrega': 'longUbicacionEntrega',
                'lng': 'longUbicacionEntrega',
                'empresa': 'empresaId',
                'empresaid': 'empresaId',
                'estado': 'estado',
                'ubicacion': 'ubicacion',
                'cliente': 'nombreCliente',
                'nombrecliente': 'nombreCliente',
                'direccion': 'direccionPuntoEntrega',
                'direccionpuntoentrega': 'direccionPuntoEntrega',
                'codigo': 'codigoSN',
                'codigosn': 'codigoSN',
                'personacliente': 'nombrePersonaCliente',
                'nombrepersonacliente': 'nombrePersonaCliente',
                'contacto': 'contactoPersonaCliente',
                'contactopersonacliente': 'contactoPersonaCliente'
            };

            return mapeoEncabezados[headerLimpio] || headerLimpio;
        },
    }
};
</script>
<style>
.text-right,
.text-danger,
.pointer mb-2 {
    display: none;
}

.table-responsive{
    height: 40vh;
    overflow: auto;
}
</style>
<style scoped>
.excel-uploader {
    border: 1px solid #ddd;
    padding: 15px;
    border-radius: 5px;
    text-align: center;
}
</style>
